import { createAction, props } from '@ngrx/store';
import { TankerLineUpReport } from '../models/tanker-line-up.model';

export const loadTankerLineupReport = createAction(
  '[Tankers Line Up Page] Load Report',
  props<{ portUuid: string | null; targetDate: string }>()
);

export const loadTankerLineupReportSuccess = createAction(
  '[Tankers Line Up Page] Load Report Success',
  props<{ report: TankerLineUpReport }>()
);

export const loadTankerLineupReportFailure = createAction(
  '[Tankers Line Up Page] Load Report Failure',
  props<{ error: any }>()
);
